/**
 * Тонкий ре-экспорт из @mnp/shared с сохранением исходных имён, под которыми
 * утилиты импортируются по всей admin-панели. Сами словари/форматтеры теперь
 * живут в shared (см. packages/shared/src/labels и /format).
 */
export {
  STATUS_LABELS_RU_ADMIN as STATUS_LABEL,
  STATUS_BADGES as STATUS_BADGE,
  STATUS_SHORT,
  STATUS_ORDER,
  DIRECTION_LABELS_RU_ADMIN as DIRECTION_LABEL,
  shortId,
  formatDate,
  formatDateTime,
  formatGel,
} from "@mnp/shared";

/**
 * Deep-link to a client's Telegram. Prefer the @username (opens the public
 * profile / DM directly), else fall back to `tg://user?id=<chatId>`. Mirrors
 * the client-card contact link so every deal can jump into the user's chat.
 */
export function telegramHref(
  handle: string | null | undefined,
  chatId: string | number | null | undefined,
): string {
  const clean = handle?.replace(/^@+/, "").trim();
  if (clean) return `https://t.me/${clean}`;
  return `tg://user?id=${chatId ?? ""}`;
}
